import React, { useEffect } from 'react';
import { FaCaretDown } from 'react-icons/fa';
import { useComponentVisible } from '../../hooks/useComponentVisible';

interface Props {
  toggleContent?: (isComponentVisible: boolean) => React.ReactElement | string;
  buttonClassName?: string;
  hideCaret?: boolean;
  position?: 'left' | 'right';
  closeOnClick?: boolean;
  disabled?: boolean;
}

const Dropdown: React.FC<Props> = ({
  children,
  buttonClassName,
  closeOnClick,
  toggleContent,
  hideCaret,
  disabled,
  position = 'right',
}) => {
  const { ref, isComponentVisible, setIsComponentVisible, closeDropdown} =
    useComponentVisible(false);
  
  // useEffect(() => {
  //   console.log("isComponentVisible dropdown-- ", isComponentVisible)
  // }, [isComponentVisible])

  // console.log("= drpdown isComponentVisible== ", isComponentVisible,)

  return (
    <div  ref={ref} className="relative h-full">
      <button
        type="button"
        disabled={disabled}
        aria-label="Dropdown"
        className={
          buttonClassName ||
          'p-2 flex items-center dark:hover:text-gray-800 hover:bg-gray-50 rounded'
        }
        onClick={() => setIsComponentVisible(!isComponentVisible)}
      >
        {toggleContent && toggleContent(isComponentVisible)}
        {!hideCaret && <FaCaretDown className="ml-2" />}
      </button>
      {isComponentVisible ? (
        <div
          {...(closeOnClick
            ? {
                // onClick: () => setIsComponentVisible(false)
                onClick: () => closeDropdown()
              }
            : {}
            )}
          className={`here ${position}-0 ${isComponentVisible ? "block absolute dark:border-gray-800  border border-gray-100 text-left top-full shadow-sm z-10 rounded w-auto dark:bg-gray-800 bg-white" : "border hidden "}`}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default Dropdown;
